// ARQUIVO 100% COMPLETO E CORRIGIDO
import React, { useState, useEffect, useMemo } from 'react';
import useData from '../../hooks/useData';
import useToast from '../../hooks/useToast';
import GlassButton from '../ui/Button';
import { SaveIcon, ResetIcon } from '../ui/Icons';
import InputField from '../ui/InputField';

const SettingsManager = ({ onClose }) => {
    const { currentUserProfile, handleUpdateProfileSettings } = useData();
    const { showToast } = useToast();
    const [settings, setSettings] = useState({ 
        monthlySalary: 4000, 
        workHoursPerMonth: 160, 
        costFactor: 1.5,
        quoteCounter: 0 
    });

    useEffect(() => {
        if (currentUserProfile) {
            setSettings({
                monthlySalary: currentUserProfile.monthlySalary || 4000,
                workHoursPerMonth: currentUserProfile.workHoursPerMonth || 160,
                costFactor: currentUserProfile.costFactor || 1.5,
                quoteCounter: currentUserProfile.quoteCounter || 0,
            });
        }
    }, [currentUserProfile]);

    const hourlyRate = useMemo(() => {
        if (!settings.workHoursPerMonth) return 0;
        return (settings.monthlySalary * settings.costFactor) / settings.workHoursPerMonth;
    }, [settings]);

    const handleSave = async () => {
        await handleUpdateProfileSettings(settings);
        showToast("Configurações salvas!");
        onClose();
    };

    return (
        <>
            <div className="space-y-6 text-white max-h-[60vh] overflow-y-auto pr-4">
                <div>
                    <h3 className="text-lg font-bold text-white mb-2">Cálculo de Valor/Hora</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white/5 p-4 rounded-lg">
                        <InputField label="Salário Mensal (R$)" type="number" value={settings.monthlySalary} onChange={e => setSettings(s => ({...s, monthlySalary: Number(e.target.value)}))} />
                        <InputField label="Horas/Mês" type="number" value={settings.workHoursPerMonth} onChange={e => setSettings(s => ({...s, workHoursPerMonth: Number(e.target.value)}))} />
                        <div className="md:col-span-2">
                            <label className="text-sm">Fator de Custos/Lucro ({((settings.costFactor - 1) * 100).toFixed(0)}%)</label>
                            <input type="range" min="1" max="3" step="0.1" value={settings.costFactor} onChange={e => setSettings(s => ({...s, costFactor: Number(e.target.value)}))} className="w-full mt-1" />
                        </div>
                        <div className="md:col-span-2 text-center bg-black/20 p-3 rounded-lg">
                            <p className="text-gray-300">Seu valor/hora calculado é:</p>
                            <p className="text-2xl font-bold text-emerald-400">{hourlyRate.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        </div>
                    </div>
                </div>
                {/* --- INÍCIO DA ALTERAÇÃO --- */}
                <hr className="border-white/10" />
                <div>
                    <h3 className="text-lg font-bold text-white mb-2">Contador de Orçamentos</h3>
                    <div className="bg-white/5 p-4 rounded-lg">
                        <div className="flex items-end gap-2">
                            <InputField 
                                label="Próximo número" 
                                type="number" 
                                value={settings.quoteCounter} 
                                onChange={e => setSettings(s => ({...s, quoteCounter: Number(e.target.value)}))}
                            />
                            <GlassButton onClick={() => setSettings(s => ({...s, quoteCounter: 0}))} variant="minimal" className="!bg-red-500/20 hover:!bg-red-500/40 mb-1" title="Resetar contador">
                                <ResetIcon />
                            </GlassButton>
                        </div>
                        <p className="text-xs text-gray-400 mt-2">O próximo orçamento salvo terá o número <span className="font-bold text-gray-300">{settings.quoteCounter + 1}</span>.</p>
                    </div>
                </div>
                 {/* --- FIM DA ALTERAÇÃO --- */}
            </div>
            
            <div className="mt-6 flex justify-end">
                <GlassButton onClick={handleSave} className="!bg-indigo-500">
                    <SaveIcon size={16}/> 
                    <span className="ml-2">Salvar e Fechar</span>
                </GlassButton>
            </div>
        </>
    );
};

export default SettingsManager;